var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPriorityHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 14,
    rx: 2,
    fill: "#FF4B62"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 5,
    height: 14,
    rx: 2,
    fill: "#FF4B62"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 5,
    height: 14,
    rx: 2,
    fill: "#FF4B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPriorityHigh);
export default __webpack_public_path__ + "static/media/icon-priority-high.b99b0e5f1fd6781357070b1284a1eaac.svg";
export { ForwardRef as ReactComponent };